
  export const  Interests = ['Baptism','Counselling','cwc','ms']

// export default {Interests};